import React, { useEffect, useState } from "react";
import CustomDropdown from "./CustomDropdown";
import { loadOptions } from "../../../utils/Utils";
import { toast } from "react-toastify";
import "./Dropdown.scss"

const DropdownItem = ({ label, value, question, onChange, checkedOption, errorMessage, error, disabled = false }) => {

    const [componentKey, setComponentKey] = useState(0);
    // Create a unique key based on the question and value
    const dropdownKey = `${question?.questionId}-${componentKey}`;

    // This creates a dedicated loadOptions function for this specific dropdown
    const loadOptionsForDropdown = loadOptions(value);

    useEffect(() => {
        // When value changes, update the component key to force a re-render
        setComponentKey(prevKey => prevKey + 1);
        console.log("Value for dropdown options:", value);
    }, [value]);

    const onChangeInputText = (e) => {
        if(disabled) {
            toast.error("Report already ready can not change the response");
            return;
        }

        // React-select uses value/label, but your code expects id/name
        const answerId = e?.value || e?.id;
        const answerText = e?.label || e?.name;

        onChange && onChange({
            question: question,
            answerId: answerId,
            answerText: answerText,
            willSave: true
        });
    }

    const getCheckedOption = (checkAnswersId) => {
        if (!question?.responses || !checkAnswersId) return null;

        const response = question.responses;
        let answerOption = response.filter((answer) => answer.id === checkAnswersId) || [];

        if(answerOption.length > 0){
            answerOption = answerOption[0];

            return {
                value: answerOption.id,
                label: answerOption.name
            };
        } else {
            return null;
        }
    }

    // Memoize the initial options to prevent unnecessary re-calculations
    const initialOptions = React.useMemo(() => {
        if (!value || value.length === 0) return [];

        const options = value.map(item => ({
            value: item.id,
            label: item.name
        }));

        return options; // Show all options instead of limiting to 10
    }, [value]);

    return (
        <div className="mmh-form-group mmh-row">
            <label className="mmh-col-left global-text-color">{label}</label>
            <div className="mmh-col-right dropdown-wrapper">
                <CustomDropdown
                    key={dropdownKey} // Add a key to force re-render when options change
                    menuPlacement="top"
                    isClearable={false}
                    isSearchable={true}
                    className="mmh-multi-select kt-p0"
                    value={getCheckedOption(checkedOption)}
                    loadOptions={loadOptionsForDropdown}
                    onChange={onChangeInputText}
                    classNamePrefix="mmh"
                    isDisabled={disabled}
                    defaultOptions={initialOptions} // Pass the initial options directly
                    cacheOptions={false} // Disable caching
                    additional={{
                        page: 0, // Reset pagination when options change
                    }}
                />
                {errorMessage && (<div className="mmh-invalid-feedback">* This field is required</div>)}
                {error && error.questionId === question.questionId && (
                    <span className="mmh-error-text mmh-text-muted kt-font-danger">* {error.message}</span>
                )}
            </div>
        </div>
    )
}

export default DropdownItem;
